var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53613 4.46729C8.53613 4.95053 8.14438 5.34229 7.66113 5.34229C7.17788 5.34229 6.78613 4.95053 6.78613 4.46729C6.78613 3.98404 7.17788 3.59229 7.66113 3.59229C8.14438 3.59229 8.53613 3.98404 8.53613 4.46729Z",
    fill: "#164A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41113 6.96729C8.41113 6.55307 8.07535 6.21729 7.66113 6.21729C7.24692 6.21729 6.91113 6.55307 6.91113 6.96729V10.4048C6.91113 10.819 7.24692 11.1548 7.66113 11.1548C8.07535 11.1548 8.41113 10.819 8.41113 10.4048V6.96729Z",
    fill: "#164A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56238 14.7263C11.5513 14.7263 14.7849 11.4927 14.7849 7.50378C14.7849 3.51489 11.5513 0.28125 7.56238 0.28125C3.57348 0.28125 0.339844 3.51489 0.339844 7.50378C0.339844 11.4927 3.57348 14.7263 7.56238 14.7263ZM7.56238 13.2263C10.7228 13.2263 13.2849 10.6643 13.2849 7.50378C13.2849 4.34332 10.7228 1.78125 7.56238 1.78125C4.40191 1.78125 1.83984 4.34332 1.83984 7.50378C1.83984 10.6643 4.40191 13.2263 7.56238 13.2263Z",
    fill: "#164A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.e175b66045a1964a7d5dffebe564f9f4.svg";
export { ForwardRef as ReactComponent };